import _objectWithoutProperties from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _excluded = ["includeFacets"];
import _regeneratorRuntime from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import createStorage from "services/storage";
import { ApiConfSeriesSearchControllerApi } from "apiclient/api/ApiConfSeriesSearchControllerApi";
import convertToPlainObject from "components/common/utils/convertToPlainObject";
var Storage = createStorage("CONFERENCE-SERIES");
var conferenceSeriesApi = new ApiConfSeriesSearchControllerApi();

// What if we just get the excludeFacets and includeFacets from tho options and then
// when the call is resolved, append these navigator values to the new navigators and also put them as selected?
// MOST APPROACHABLE SOLUTION SOS: we need both of  excludeFacets and includeFacets merged
// ans stripped from duplicates because the user might have a complex query
// This requires that the API call will respond with ONLY remaining navigators based on what it receives in the query
//
export var fetchConferenceSeries = createAsyncThunk("conferenceseries/get", /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(options) {
    var _data$content, _data$first, _data$hasContent, _data$last, _yield$conferenceSeri, _yield$conferenceSeri2, navigators, _yield$conferenceSeri3, data, _e$response, _e$response$body, _errorMsg;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (options !== null && options !== void 0 && options.page) {
              options.page = +options.page - 1;
            }
            _context.prev = 1;
            _context.next = 4;
            return conferenceSeriesApi.searchConfSeriesPost(options);
          case 4:
            _yield$conferenceSeri = _context.sent;
            _yield$conferenceSeri2 = _yield$conferenceSeri.navigators;
            navigators = _yield$conferenceSeri2 === void 0 ? [] : _yield$conferenceSeri2;
            _yield$conferenceSeri3 = _yield$conferenceSeri.conferenceSeries;
            data = _yield$conferenceSeri3 === void 0 ? {} : _yield$conferenceSeri3;
            return _context.abrupt("return", {
              navigators: convertToPlainObject(navigators.map(function (nav) {
                return _objectSpread(_objectSpread({}, nav), {}, {
                  selectedItems: []
                });
              })),
              entities: convertToPlainObject((_data$content = data === null || data === void 0 ? void 0 : data.content) !== null && _data$content !== void 0 ? _data$content : []),
              pagination: {
                first: (_data$first = data === null || data === void 0 ? void 0 : data.first) !== null && _data$first !== void 0 ? _data$first : true,
                hasContent: (_data$hasContent = data === null || data === void 0 ? void 0 : data.hasContent) !== null && _data$hasContent !== void 0 ? _data$hasContent : false,
                last: (_data$last = data === null || data === void 0 ? void 0 : data.last) !== null && _data$last !== void 0 ? _data$last : false,
                number: data !== null && data !== void 0 && data.number ? Number(data.number) + 1 : 1,
                size: data !== null && data !== void 0 && data.size ? Number(data.size) : 10,
                totalPages: data !== null && data !== void 0 && data.totalPages ? Number(data.totalPages) : 0
              }
            });
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
            _errorMsg = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_e$response = _context.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$body = _e$response.body) === null || _e$response$body === void 0 ? void 0 : _e$response$body.message;
            if (!_errorMsg.startsWith("400 Failed to parse query")) {
              _context.next = 17;
              break;
            }
            return _context.abrupt("return", {
              navigators: [],
              entities: [],
              pagination: {
                first: true,
                hasContent: false,
                last: false,
                number: 1,
                size: options !== null && options !== void 0 && options.size ? Number(options.size) : 10,
                totalPages: 0
              }
            });
          case 17:
            throw _context.t0;
          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 12]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}());
var initialState = {
  status: "init",
  navigators: [],
  entities: [],
  pagination: {},
  expandedNavigators: {},
  isSynced: false,
  filters: {
    includeFacets: {},
    search: "",
    page: 1,
    size: 10
  }
};
var conferenceSeriesSlice = createSlice({
  name: "conferenceSeries",
  initialState: initialState,
  reducers: {
    syncStorage: function syncStorage(state) {
      var storaged = Storage.get();
      if (storaged) {
        state.filters = storaged.filters;
        state.expandedNavigators = storaged.expandedNavigators;
      }
      state.isSynced = true;
    },
    updateExpanded: function updateExpanded(state, _ref2) {
      var payload = _ref2.payload;
      state.expandedNavigators = _objectSpread(_objectSpread({}, state.expandedNavigators), payload);
      Storage.set(state);
    },
    updateFilter: function updateFilter(state, _ref3) {
      var _ref3$payload = _ref3.payload;
      _ref3$payload = _ref3$payload === void 0 ? {} : _ref3$payload;
      var key = _ref3$payload.key,
        value = _ref3$payload.value;
      state.filters[key] = value;
      if (key !== "page") {
        state.filters.page = 1;
      }
      Storage.set(state);
    },
    updateFilters: function updateFilters(state, _ref4) {
      var _ref5;
      var _ref4$payload = _ref4.payload;
      _ref4$payload = _ref4$payload === void 0 ? {} : _ref4$payload;
      var includeFacets = _ref4$payload.includeFacets,
        rest = _objectWithoutProperties(_ref4$payload, _excluded);
      state.filters = _objectSpread(_objectSpread(_objectSpread({}, state.filters), rest), {}, {
        includeFacets: (_ref5 = includeFacets !== null && includeFacets !== void 0 ? includeFacets : state.filters.includeFacets) !== null && _ref5 !== void 0 ? _ref5 : {}
      });
      if (!rest.page) {
        state.filters.page = 1;
      }
      Storage.set(state);
    },
    clearFilters: function clearFilters(state) {
      state.filters = _objectSpread({}, initialState.filters);
      state.isSynced = true;
      Storage.set(state);
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(fetchConferenceSeries.pending, function (state) {
      state.status = "pending";
    }).addCase(fetchConferenceSeries.fulfilled, function (state, _ref6) {
      var payload = _ref6.payload;
      state.status = "done";
      state.navigators = payload.navigators;
      state.entities = payload.entities;
      state.pagination = payload.pagination;
    }).addCase(fetchConferenceSeries.rejected, function (state) {
      state.status = "error";
    });
  }
});
export var selectConferenceSeries = function selectConferenceSeries(state) {
  return state.conferenceSeries.entities;
};
export var selectConferenceSeriesStatus = function selectConferenceSeriesStatus(state) {
  return state.conferenceSeries.status;
};
export var selectConferenceSeriesNavigators = function selectConferenceSeriesNavigators(state) {
  return state.conferenceSeries.navigators;
};
export var selectConferenceSeriesPagination = function selectConferenceSeriesPagination(state) {
  return state.conferenceSeries.pagination;
};
export var selectFilters = function selectFilters(state) {
  return state.conferenceSeries.filters;
};
export var selectExpanded = function selectExpanded(state) {
  return state.conferenceSeries.expandedNavigators;
};
export var SelectCSP = function SelectCSP(state) {
  return state.conferenceSeries;
};
var actions = conferenceSeriesSlice.actions;
export { actions };
export var toQueryString = function toQueryString(search) {
  if (/^[a-zA-Z0-9]+$/.test(search)) {
    return "".concat(search, " *").concat(search, "*");
  }
  return search;
};
export default conferenceSeriesSlice.reducer;